// POSTs to a Cloudflare Worker (see /scratchpad/drop-a-hint-worker/worker.js in this project) which
// sends a branded email to the friend via Resend. The API key lives only on the Worker, never here.

const HINT_ENDPOINT = 'https://drop-a-hint-attentive-proxy.drop-a-hint-worker.workers.dev';

class DropAHintForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.status = this.querySelector('.drop-a-hint-form__status');
    this.previewTargets = this.querySelectorAll('[data-hint-preview]');

    if (!this.form) {
      return;
    }

    this.previewDefaults = new Map();
    this.previewTargets.forEach((el) => {
      this.previewDefaults.set(el.dataset.hintPreview, el.textContent);
    });

    this.onSubmit = this.onSubmit.bind(this);
    this.onInput = this.onInput.bind(this);
    this.form.addEventListener('submit', this.onSubmit);
    this.form.addEventListener('input', this.onInput);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
    this.form?.removeEventListener('input', this.onInput);
  }

  onInput(event) {
    const field = event.target.name;

    if (!field) {
      return;
    }

    const target = this.querySelector(`[data-hint-preview="${field}"]`);

    if (!target) {
      return;
    }

    const value = event.target.value.trim();

    if (field === 'message') {
      target.textContent = value ? `"${value}"` : '';
      target.hidden = !value;
      return;
    }

    target.textContent = value || this.previewDefaults.get(field);
  }

  setStatus(message) {
    if (this.status) {
      this.status.textContent = message;
      this.status.hidden = false;
    }
  }

  async onSubmit(event) {
    event.preventDefault();

    const submitButton = this.form.querySelector('[type="submit"]');
    submitButton?.setAttribute('aria-busy', 'true');

    const formData = new FormData(this.form);

    const body = {
      sender_name: formData.get('sender_name'),
      sender_email: formData.get('sender_email'),
      receiver_name: formData.get('receiver_name'),
      receiver_email: formData.get('receiver_email'),
      message: formData.get('message'),
      product_title: this.form.dataset.productTitle,
      product_url: this.form.dataset.productUrl,
      product_image: this.form.dataset.productImage,
      consent: formData.get('consent') === 'on',
    };

    try {
      const response = await fetch(HINT_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error('Request failed');
      }

      this.setStatus(this.dataset.sentMessage);
      this.form.reset();
      this.previewTargets.forEach((el) => {
        const field = el.dataset.hintPreview;
        el.textContent = this.previewDefaults.get(field);
        if (field === 'message') {
          el.hidden = true;
        }
      });
    } catch (error) {
      console.error('[drop-a-hint]', error);
      this.setStatus(this.dataset.errorMessage);
    } finally {
      submitButton?.removeAttribute('aria-busy');
    }
  }
}

if (!window.customElements.get('drop-a-hint-form')) {
  window.customElements.define('drop-a-hint-form', DropAHintForm);
}
